import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { UPLOAD_SOURCES } from '@cld/upload-widget';
import TabPanel from 'tabs/hocs/TabPanel';
import rootActions, { types as rootAts } from 'root/actions';
import LoginIntro from '../common/components/LoginIntro';
import Footer from '../common/components/Footer';
import { useAuth } from '../common/selectors';
import { useGettyServer, useCloudName, useNewTlsDomain } from '../common/getty-selectors';
import AuthContent from '../common/components/AuthContent';
import { ROUTES, FILTERS_BY_MEDIA_TYPE } from '../common/data/consts';
import getGettyService from './service';
import actions from './actions/actions';
import { FILTERS_MAP } from './data/filtersMap';

const { [rootAts.ADD_UPLOAD_TO_QUEUE]: handleUploadAssetAction } = rootActions.creators;
const { GETTY } = UPLOAD_SOURCES;

export const GettyTab = ({ routes }) => {
  const { isSignedIn, isAuthInProgress } = useAuth(GETTY);
  const dispatch = useDispatch();
  const cloudName = useCloudName();
  const server = useGettyServer();
  const newTlsDomain = useNewTlsDomain();

  const gettyService = useCallback(() => getGettyService(), []);

  const handleTogglePanel = useCallback(() => {
    dispatch(actions.handleTogglePanelAction());
  }, [dispatch]);

  const handleUploadAsset = useCallback(
    (payload) => {
      dispatch(handleUploadAssetAction(payload));
    },
    [dispatch]
  );

  const handlePurchaseAsset = useCallback(() => {
    dispatch(actions.handlePurchaseAssetAction());
  }, [dispatch]);

  const onAuthActionClick = useCallback(() => {
    gettyService().openAuthWindow({
      cloudName,
      server,
      newTlsDomain,
    });
  }, [gettyService, cloudName, server, newTlsDomain]);

  return (
    <div
      className={cx('content-wrap bg-source-bg bg-source-bg-c getty-block', {
        'user-active': isSignedIn,
      })}
    >
      {!isSignedIn && (
        <div className="holder large-thin-menu-holder ">
          <LoginIntro
            handleLoginAction={actions.handleLoginAction}
            source={GETTY}
            service={gettyService}
            onAuthActionClick={onAuthActionClick}
            cloudName={cloudName}
            isAuthInProgress={isAuthInProgress}
          />
        </div>
      )}
      {isSignedIn && (
        <AuthContent
          routes={routes}
          source={GETTY}
          filtersMap={FILTERS_MAP}
          applicationRoutes={ROUTES}
          actions={actions}
          filtersByMediaType={FILTERS_BY_MEDIA_TYPE}
        />
      )}
      <Footer routes={ROUTES} source={GETTY} togglePanel={handleTogglePanel} uploadAsset={handleUploadAsset} purchaseAsset={handlePurchaseAsset} />
    </div>
  );
};

export default TabPanel({
  id: GETTY,
})(GettyTab);
